export function loadFacebookSDK(appId) {
  return new Promise(resolve => {
    if (window.FB) {
      resolve(window.FB);
      return;
    }

    // SDK initialization
    window.fbAsyncInit = function () {
      window.FB.init({
        appId, // your app ID goes here
        autoLogAppEvents: true,
        xfbml: true,
        version: 'v23.0', // Graph API version goes here
      });
    };

    // Inject Facebook SDK script
    const script = document.createElement('script');
    script.src = 'https://connect.facebook.net/en_US/sdk.js';
    script.async = true;
    document.body.appendChild(script);
  });
}
